import { AgmMap, MapsAPILoader } from '@agm/core';
import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit, ElementRef, NgZone } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { BehaviorSubject, combineLatest, forkJoin, fromEvent, merge, Observable, Subject, Subscription } from 'rxjs';
// import {User} from '../../../../../core/auth';
import { TranslateService } from '@ngx-translate/core';
// tslint:disable-next-line: max-line-length
import {
    AcSource, AssetClassMapPageRequested,
    AssetClassResidentialModel, AssetClassResidentialsDataSource,
    AssetClassResidentialsService,
    OneAssetClassResidentialDeleted,
    selectAdminTrashedAssetClassResidentialCount,
    selectAssetClassResidentialsLastQuery,
    selectTrashedAssetClassResidentialCount
} from '../../../../../core/comparable';
import { AppState } from '../../../../../core/reducers';
import { LayoutUtilsService, QueryParamsModel, TypesUtilsService } from '../../../../../core/_base/crud';
import { LayoutConfigService, SubheaderService } from '../../../../../core/_base/layout';
import { debounceTime, distinctUntilChanged, tap, take, map } from 'rxjs/operators';
// import {FilterModel} from '../../_sub/filter-dialog/filter.model';
import { FilterDialogComponent } from '../../_sub/filter-dialog/filter-dialog.component';
import { MarkerInfoDialogComponent } from '../../_sub/map-info-dialog/marker-info-dialog.component';
import { Overlay } from '@angular/cdk/overlay';
import { fetchMapMarkers } from 'src/app/core/_base/crud/utils/map-marker.util';
import { ComparableMarkerLayer, MarkerLayerPin } from 'src/app/core/map/comparable-marker-layer';
import { ComparableMapPin, ComparableMapService } from 'src/app/core/comparable/_services/comparable-map.service';
import { MapMarkerInfoWindowComponent, MapMarkerInfoWindowDialogInput } from '../../../shared_components/map-marker-info-window/map-marker-info-window.component';
import { ToMarkerItemConverterService } from '../../../shared_components/map-marker-info-window/to-marker-item-converter-service.service';
import { emptyFilter, FilterChange, FilterModel } from '../../../shared_components/filter-section/filter-section.component';
import { ApartmentTrashFlushed, AssetClassResidentialActionToggleLoading, AssetClassResidentialDeletedFromAdminTrash, AssetClassResidentialDeletedFromTrash, AssetClassResidentialDuplicate, AssetClassResidentialOnServerAdminRestored, AssetClassResidentialOnServerRestored } from 'src/app/core/comparable/_actions/asset-class-residential.actions';
import { User, currentUser, hasPermission } from 'src/app/core/mad-auth/mad-auth.store';
import { environment } from 'src/environments/environment';
import { MapsService } from 'src/app/core/map/maps.service';
import { FileUploadService } from 'src/app/core/file-upload';
import { zoomForViewport } from 'src/app/core/v2/map/viewport-to-zoom';
import { parcelCharacteristicsReducer } from 'src/app/core/linked-tables';


@Component({
    selector: 'kt-apartment-edit',
    templateUrl: './apartment-map.component.html',
    styleUrls: ['./apartment-map.component.scss'],
})
export class ApartmentMapComponent implements OnInit, OnDestroy, AfterViewInit {

    icon = {
        url: './assets/media/icons/my_marker.svg'
    };

    displayedColumns = ['id', 'sub_type', 'city', 'community', 'building_id', 'size', 'consideration', 'source_date', 'actions'];
    dataSource: AssetClassResidentialsDataSource;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild('sort1', { static: true }) sort: MatSort;

    @ViewChild('search', { static: false })
    public searchElementRef: ElementRef;
    // @ViewChild('searchLocation', {static: true}) searchElementRef: ElementRef;
    // @ViewChild('searchInput', {static: true}) searchInput: ElementRef;
    assetClassResidentialResult: AssetClassResidentialModel[] = [];

    marker: google.maps.Marker;
    mapAction = new BehaviorSubject<boolean>(true);
    previous;


    private componentSubscriptions: Subscription;
    subscriptions: Subscription[] = [];
    // currentUser: User;
    saveState: boolean;

    loading$: Observable<boolean>;
    hasFormErrors = false;

    // map
    @ViewChild('AgmMap', { static: true }) agmMap: AgmMap;
    @ViewChild('fileInput') fileInput;
    fileType = 'application/json';
    isFirst = true;
    latLngSW: google.maps.LatLng;
    latLngNE: google.maps.LatLng;
    map: any;
    zoom = 15;
    private _centerLat$ = new BehaviorSubject<number>(null)
    centerLatitude$ = combineLatest([
        this._centerLat$.asObservable(),
        this.mapsService.latitude$
    ]).pipe(
        map(([lat, _default]) => {
            if (lat === null) return _default
            return lat
        })
    );
    private _centerLng$ = new BehaviorSubject<number>(null)
    centerLongitude$ = combineLatest([
        this._centerLng$.asObservable(),
        this.mapsService.longitude$
    ]).pipe(
        map(([lat, _default]) => {
            if (lat === null) return _default
            return lat
        })
    );
    currentCenter: { lat: 0, lng: 0 };
    _north = new BehaviorSubject<number>(47.92399006317647);
    _south = new BehaviorSubject<number>(47.9096089375195);
    _east = new BehaviorSubject<number>(106.9476215928344);
    _west = new BehaviorSubject<number>(106.8833344071655);

    filterModel: FilterModel = emptyFilter();
    filterCnt = 0;
    private modal;
    filter$: BehaviorSubject<FilterModel> = new BehaviorSubject(this.filterModel);
    filterObs$ = this.filter$.asObservable();

    // Last Query Params
    lastQueryParams: QueryParamsModel;
    trashCnt = 0;
    adminTrashCnt = 0;
    canAccessAdminTrash$ = this.store.pipe(select(hasPermission(['admin_trash'])))
    currentUser: User | null;
    /**
     * Drives the map's own request. The table's request is paginated; the map's is not, so
     * the two cannot share one -- with 25 rows a page the map used to draw 25 markers and
     * silently drop every other comparable in the viewport.
     */
    private _mapFilter$ = new Subject<FilterModel>();
    /**
     * Drives the table's page request. AGM emits boundsChange continuously while the map is
     * panned or zoomed, and each one used to dispatch a page request of its own -- a burst of
     * them per drag, against the list endpoint that reads every row's relations.
     */
    private _listRequest$ = new Subject<void>();
    /**
     * One entry per distinct coordinate, kept here rather than rendered through the
     * template: `ComparableMarkerLayer` draws them straight onto the map. Held so a layer
     * created after the first response still gets what has already been fetched.
     */
    private _pins: MarkerLayerPin<ComparableMapPin>[] = []
    private _markerLayer: ComparableMarkerLayer<ComparableMapPin> = null

    private geoCoder = new google.maps.Geocoder();
    /**
     * Component constructor
     *
     * @param assetClassResidentialsService: AssetClassResidentialsService
     * @param activatedRoute: ActivatedRoute
     * @param router: Router
     * @param fb: FormBuilder
     * @param location: Location
     * @param subheaderService: SubheaderService
     * @param typesUtilsService: TypesUtilsService
     * @param layoutUtilsService: LayoutUtilsService
     * @param store: Store
     * @param dialog: Dialog
     * @param overlay: Overlay
     * @param mapsAPILoader: MapsAPILoader
     * @param ngZone: NgZone
     * @param layoutConfigService: LayoutConfigService
     * @param translate: TranslateService
     */
    constructor(public assetClassResidentialsService: AssetClassResidentialsService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private location: Location,
        private subheaderService: SubheaderService,
        public typesUtilsService: TypesUtilsService,
        private layoutUtilsService: LayoutUtilsService,
        private store: Store<AppState>,
        public dialog: MatDialog,
        public overlay: Overlay,
        private mapsAPILoader: MapsAPILoader,
        private ngZone: NgZone,
        private layoutConfigService: LayoutConfigService,
        private translate: TranslateService,
        public service: AssetClassResidentialsService,
        private comparableMapService: ComparableMapService,
        private toMarkerItemService: ToMarkerItemConverterService,
        private mapsService: MapsService,
        private fileUploadService: FileUploadService
    ) {
        this.saveState = false;
    }

    ngAfterViewInit(): void {

    }

    ngOnInit() {
        const userSub = this.store.select(currentUser).subscribe(user => this.currentUser = user)
        this.subscriptions.push(userSub);
        // this.filterModel = new FilterModel();
        // this.filterModel.clear();

        this.loading$ = this.mapAction.asObservable();

        this.paginator._intl.itemsPerPageLabel = 'Display';
        // If the user changes the sort order, reset back to the first page.
        const sortSubscription = this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
        this.subscriptions.push(sortSubscription);

        /* Data load will be triggered in two cases:
        - when a pagination event occurs => this.paginator.page
        - when a sort event occurs => this.sort.sortChange
        **/
        const paginatorSubscriptions = merge(this.sort.sortChange, this.paginator.page).pipe(
            tap(() => this.loadList())
        ).subscribe();
        this.subscriptions.push(paginatorSubscriptions);


        this.dataSource = new AssetClassResidentialsDataSource(this.store);
        const entitiesSubscription = this.dataSource.entitySubject.subscribe(res => {
            this.assetClassResidentialResult = res;
            this.mapAction.next(false);
        });

        this.subscriptions.push(entitiesSubscription);

        const listSubscription = this._listRequest$.pipe(

            debounceTime(300)

        ).subscribe(() => this._dispatchList());

        this.subscriptions.push(listSubscription);


        const markersSubscription = fetchMapMarkers<ComparableMapPin>(
            this._mapFilter$.asObservable(),
            filter => this.comparableMapService.load(1, filter)
        ).subscribe(res => this._setMarkers(res));
        this.subscriptions.push(markersSubscription);

        // Last Query Params
        this.lastQueryParams = new QueryParamsModel({});
        const lastyQueryParamsSubscriptions = this.store.pipe(
            select(selectAssetClassResidentialsLastQuery),
            take(1)
        ).subscribe(res => {
            if (res.isEmpty()) {
                return;
            }
            this.lastQueryParams = res;
            this.updateFilter(res.filter);
        });
        this.subscriptions.push(lastyQueryParamsSubscriptions);

        const selectTrashedSubscription = this.store.pipe(
            select(selectTrashedAssetClassResidentialCount)
        ).subscribe(res => {
            this.trashCnt = res;
        });
        this.subscriptions.push(selectTrashedSubscription);

        const selectAdminTrashedSubscription = this.store.pipe(
            select(selectAdminTrashedAssetClassResidentialCount)
        ).subscribe(res => {
            this.adminTrashCnt = res;
        });
        this.subscriptions.push(selectAdminTrashedSubscription);
    }

    onFilterChange(event: FilterChange) {
        if (event.page != null) {
            this.paginator.pageIndex = event.page
        }
        // The filter section keeps its own copy of the model and never learns about the
        // map's viewport, so its filter always comes back with bounds cleared. Keeping the
        // bounds the map last reported is what stops a filter change fetching the world.
        this.filterModel = Object.assign({}, event.filter, {
            bounds: event.filter.bounds ? event.filter.bounds : this.filterModel.bounds
        }) as FilterModel;
        this.loadList();
        this._loadMapMarkers();
    }

    ngOnDestroy(): void {
        if (this._markerLayer) {
            this._markerLayer.destroy()
        }
        if (this.componentSubscriptions) {
            this.componentSubscriptions.unsubscribe();
        }
        this.subscriptions.forEach(_subscription => {
            _subscription.unsubscribe();
        });
    }

    back() {
        this.location.back();
    }

    /**
     * Alert close event
     */
    onAlertClose($event) {
        this.hasFormErrors = false;
    }

    navToList() {
        // this.router.navigate(['../'], {relativeTo: this.activatedRoute});
        const url = `${this.layoutConfigService.getCurrentMainRoute()}/comparable/apartments`;
        this.router.navigate([url], { relativeTo: this.activatedRoute });
    }




    /** ACTIONS */
    /**
     * Deleting comparabable residential into trash
     *
     * @param _item: AssetClassResidentialModel
     */
    deleteAssetClassResidential(_item: AssetClassResidentialModel) {
        this.store.dispatch(new OneAssetClassResidentialDeleted({ id: _item.id }));
        //
        // const index = this.assetClassResidentialResult.findIndex(e => e.id == _item.id);
        // if (index) {
        //     this.assetClassResidentialResult.slice(index, 1);
        //     // this.dataSource.data = this.assetClassResidentialResult;
        // }
    }

    addResidential() {
        this.editAssetClassResidential(null);
    }

    editAssetClassResidential(assetClassResidentialModel: AssetClassResidentialModel) {
        if (assetClassResidentialModel) {
            this.router.navigate(['../edit', assetClassResidentialModel.id], { relativeTo: this.activatedRoute });
        } else {
            this.router.navigate(['../add'], { relativeTo: this.activatedRoute });
        }
    }

    /** Rebuilt from scratch on every response, so markers never outlive the filter that produced them. */
    private _setMarkers(pins: ComparableMapPin[]) {
        const grouped = new Map<string, MarkerLayerPin<ComparableMapPin>>()
        pins.forEach(pin => {
            // A comparable recorded without coordinates has nowhere to sit on the map;
            // it stays in the list view only.
            if (pin.latitude == null || pin.longitude == null) return
            const key = pin.latitude + '_' + pin.longitude
            const existing = grouped.get(key)
            if (existing) {
                existing.title = existing.title + '/' + pin.refNum
                existing.items.push(pin)
            } else {
                grouped.set(key, {
                    key,
                    title: pin.refNum,
                    latitude: pin.latitude,
                    longitude: pin.longitude,
                    items: [pin]
                })
            }
        })

        this._pins = Array.from(grouped.values())
        if (this._markerLayer) {
            this._markerLayer.setPins(this._pins)
        }
    }

    private _loadMapMarkers() {
        this._mapFilter$.next(Object.assign({}, this.filterModel) as FilterModel);
    }

    loadList() {
        this._listRequest$.next();
    }

    private _dispatchList() {
        let queryParams = null;
        if (this.lastQueryParams.isEmpty()) {
            queryParams = new QueryParamsModel(
                this.filterModel,
                this.sort.direction,
                this.sort.active,
                this.paginator.pageIndex + 1,
                this.paginator.pageSize
            );
        } else {
            queryParams = this.lastQueryParams;
        }
        // Call request from server
        this.lastQueryParams = new QueryParamsModel({});
        this.store.dispatch(new AssetClassMapPageRequested({ page: queryParams }));
    }

    // resetFilter(): any {
    //     this.filterCnt = 0;
    //     const _new = new FilterModel();
    //     _new.clear();

    //     _new.max_lng = this.filterModel.max_lng;
    //     _new.min_lat = this.filterModel.min_lat;
    //     _new.max_lat = this.filterModel.max_lat;
    //     _new.min_lng = this.filterModel.min_lng;

    //     _new.sw_lat = this.filterModel.sw_lat;
    //     _new.ne_lat = this.filterModel.ne_lat;
    //     _new.sw_lng = this.filterModel.sw_lng;
    //     _new.ne_lng = this.filterModel.ne_lng;

    //     this.filterModel = _new;

    //     this.searchElementRef.nativeElement.value = '';
    //     this.searchInput.nativeElement.value = '';

    //     this.lastQueryParams = new QueryParamsModel({});
    //     this.loadList();
    // }

    getDate(_source: AcSource): Date {
        const _dateStr = _source.source_type_id == 1 ? _source.transaction_date : _source.information_date;
        return new Date(_dateStr);
    }

    goList() {
        this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }


    // showFilter() {
    //     const dialogRef = this.dialog.open(FilterDialogComponent, {
    //         data: {
    //             filter: this.filterModel
    //         }
    //     });

    //     dialogRef.afterClosed().subscribe((res) => {
    //         if (!res) {
    //             return;
    //         }

    //         this.filterModel = res.filter as FilterModel;
    //         this.filterCnt = FilterModel.fCount(this.filterModel);
    //         this.loadList();
    //         return;
    //     });
    // }

    updateFilter(filter: FilterModel) {
        // this.searchInput.nativeElement.value = filter.name;
        // this.searchElementRef.nativeElement.value = filter.city_name;
        // this.filterModel = filter;
        // this.filterCnt = FilterModel.fCount(this.filterModel);

        // this._north.next(filter.max_lat);
        // this._south.next(filter.min_lat);

        // this._east.next(filter.max_lng);
        // this._west.next(filter.min_lng);
        this.filter$.next(filter);
    }

    setLocation() {
        this.setCurrentLocation();
    }

    // Get Current Location Coordinates
    private setCurrentLocation() {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                if (position.coords.latitude && position.coords.longitude) {
                    this.zoom = 15;
                }
            });
        } else {
            alert('Position not available');
        }
    }


    zoomChanged($event) {
        this.isFirst = true;
    }

    boundsChanged(_latLngBound) {
        if (_latLngBound == null) {
            return;
        }

        this.latLngNE = _latLngBound.getNorthEast();
        this.latLngSW = _latLngBound.getSouthWest();

        const xPadding = (this.latLngNE.lat() - this.latLngSW.lat()) * 0.08;
        this._north.next(this.latLngNE.lat() - xPadding);
        this._south.next(this.latLngSW.lat() + xPadding);

        this._east.next(this.latLngNE.lng() - xPadding);
        this._west.next(this.latLngSW.lng() + xPadding);
        const _new = Object.assign({}, this.filterModel) as FilterModel;
        // _new.max_lat = this._north.value;
        // _new.max_lng = this._east.value;
        // _new.min_lat = this._south.value;
        // _new.min_lng = this._west.value;

        if (_new.bounds == null) {
            _new.bounds = { ne_lat: 0, sw_lat: 0, ne_lng: 0, sw_lng: 0 }
        } else {
            _new.bounds = Object.assign({}, _new.bounds);
        }
        _new.bounds.sw_lat = _latLngBound.getSouthWest().lat();
        _new.bounds.ne_lat = _latLngBound.getNorthEast().lat();
        _new.bounds.sw_lng = _latLngBound.getSouthWest().lng();
        _new.bounds.ne_lng = _latLngBound.getNorthEast().lng();

        this.filterModel = _new;

        if (this.isFirst) {
            if (this.modal) {
                this.modal.close();
            }
            this.previous = null;
            this.mapAction.next(true);
            this.isFirst = !this.isFirst;
            this.paginator.pageIndex = 0;
        }
        this.loadList();
        this._loadMapMarkers();
    }

    /**
     * The markers carry only what a pin needs, so the records behind the one clicked are
     * fetched here -- a handful of comparables at one coordinate, not a viewport of them.
     */
    showInfo(pins: ComparableMapPin[]) {
        // The service types this as the model, but the endpoint wraps it in a resource.
        forkJoin(pins.map(pin => this.service.getAssetClassResidential(pin.id))).subscribe(responses => {
            this._openInfoWindow(responses.map(res => (res as any).data));
        });
    }

    private _openInfoWindow(items: any[]) {
        const data = this.toMarkerItemService.convert('comparable', items.map(id => ({ ...id, ac_type: 1 })));
        this.dialog.open<MapMarkerInfoWindowComponent, MapMarkerInfoWindowDialogInput>(MapMarkerInfoWindowComponent, {
            data: {
                modal_title: data.modal_title,
                entities: data.entities
            }
        });
    }

    mapReady(event: any) {

        // agmMap
        this.map = event;
        this.map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(document.getElementById('Profile'));

        this._markerLayer = new ComparableMarkerLayer<ComparableMapPin>(
            this.map,
            this.ngZone,
            {
                iconUrl: this.icon.url,
                labelClassName: (_pin, isStack) => isStack ? 'bg-marker-stack' : 'bg-marker'
            },
            pins => this.showInfo(pins)
        )
        this._markerLayer.setPins(this._pins)

        this.map.addListener('dragend', () => {

            this.mapAction.next(true);
            this.paginator.pageIndex = 0;
            this.loadList();
        });

        this.mapsAPILoader.load().then(() => {
            this.geoCoder = new google.maps.Geocoder();
            if (this.searchElementRef) {
                const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
                    types: ['geocode']
                });
                autocomplete.addListener('place_changed', () => {
                    this.ngZone.run(() => {
                        // get the place result
                        const place: google.maps.places.PlaceResult = autocomplete.getPlace();
                        // verify result
                        if (place.geometry === undefined || place.geometry === null) {
                            return;
                        }

                        // set latitude, longitude and zoom
                        this._centerLat$.next(place.geometry.location.lat())
                        this._centerLng$.next(place.geometry.location.lng())
                        this.zoom = zoomForViewport(place.geometry.viewport);
                    });
                });
            }
        });
    }

    centerChange($event: any) {
        if ($event) {
            this.currentCenter = { lat: $event.lat, lng: $event.lng };
        }
    }

    mapClick(event: any) {
        if (this.modal) {
            this.modal.close();
        }

        this.modal = null;
    }

    getItemCssClassByStatus(status: number): string {
        switch (status) {
            case 0:
                return 'warning';
            case 2:
                return 'info';
            default:
                return 'success';
        }
    }
    getItemStatusString(status: number): string {
        switch (status) {
            case 0:
                return 'Draft';
            case 2:
                return 'imported';
            default:
                return 'Validated';
        }
    }

    trash() {
        this.store.dispatch(new AssetClassResidentialActionToggleLoading({ isLoading: true }));
        this.service.getTrashed().subscribe(res => {
            this.store.dispatch(new AssetClassResidentialActionToggleLoading({ isLoading: false }));
            const items = [];
            res.data.forEach(elem => {
                items.push({
                    text: `#${elem.ref_num} - ${elem.residential_type_name}`,
                    id: elem.id.toString(),
                    date: elem.user_deleted,
                    deletedUser: elem.userDeletedBy,
                    hasPermanentlyDelete: true
                });
            });
            this.show_trash(items);
        });
    }

    // Fetch admin trash data
    adminTrash() {
        this.store.dispatch(new AssetClassResidentialActionToggleLoading({ isLoading: true }));
        this.service.getAdminTrashed().subscribe(res => {

            this.store.dispatch(new AssetClassResidentialActionToggleLoading({ isLoading: false }));
            const items = [];
            res.data.forEach(elem => {
                items.push({
                    text: `#${elem.ref_num} - ${elem.residential_type_name}`,
                    id: elem.id.toString(),
                    hasPermanentlyDelete: true,
                    date: elem.deleted_at,
                    deletedUser: elem.deletedBy,
                });
            });
            this.show_trash(items, true);
        });
    }

    show_trash(items: any[], isAdmin = false) {
        let _title = this.translate.instant('APARTMENT.LIST.DIALOG.SHOW_TRASH.TITLE');
        if (isAdmin) {
            _title = this.translate.instant('APARTMENT.LIST.DIALOG.SHOW_TRASH.TITLE_ADMIN');
        }

        this.layoutUtilsService.trashedEntities(_title, items, this, isAdmin);
    }

    restore(_id: number, isAdmin = false) {
        if (isAdmin) {
            this.store.dispatch(new AssetClassResidentialOnServerAdminRestored({ id: _id }));
        } else {
            this.store.dispatch(new AssetClassResidentialOnServerRestored({ id: _id }));
        }

    }

    delete(id: number) {
        this.store.dispatch(new AssetClassResidentialDeletedFromTrash({ assetClassResidentialId: id }));
    }

    hardDelete(id: number) {
        this.store.dispatch(new AssetClassResidentialDeletedFromAdminTrash({ id }));
    }


    flush() {
        this.store.dispatch(new ApartmentTrashFlushed());
    }

    duplicate(id: number) {
        this.store.dispatch(new AssetClassResidentialDuplicate({ id }));
    }

    importComparable(event: any) {
        const file: File = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file, file.name);
        this.fileUploadService.uploadCompJson(formData).subscribe(
            (res) => {
                if (!res) {
                    return;
                }
                if (res.success) {
                    this.loadList();
                }
            },
            (err) => console
        );
    }

    /** The community is kept as the location's locality. */
    communityName(acr: any): string {
        const localities = acr && acr.locationData ? acr.locationData.localities : null;
        if (!localities || localities.length === 0) {
            return 'N/A';
        }
        const names = localities.map(locality => locality.value).filter(value => !!value);
        return names.length > 0 ? names.join(', ') : 'N/A';
    }
}
